import { render } from "./NetworkSelector.vue?vue&type=template&id=4b06b3b5"
import script from "./NetworkSelector.vue?vue&type=script&lang=js"
export * from "./NetworkSelector.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__